import * as React from "react";

import "./crop-mode.scss";

import {cs}       from "@Common/react/chain-services";
import {keyed}    from "@Common/react/keyed";
import {UseState} from "@Common/react/use-state";

import {DesktopControlPanel} from "../common/desktop-control-panel/desktop-control-panel";
import {MobileControlPanel}  from "../common/mobile-control-panel/mobile-control-panel";

import {AspectRatioControl} from "./aspect-ratio-control/aspect-ratio-control";
import {AutoRect}           from "./auto-rect";
import {DraggingRectMode}   from "./dragging-rect-mode/dragging-rect-mode";
import {DrawingRectMode}    from "./drawing-rect-mode/drawing-rect-mode";

export const CropMode = ({onDone, getColor, next}) => cs(
    ["aspectRatio", (_, next) => UseState({
        // initValue: {width: 2, height: 3},
        next,
    })],
    ["drawing" , ({aspectRatio}, next) => DrawingRectMode ({aspectRatio: aspectRatio.value, next})],
    ["dragging", ({aspectRatio}, next) => DraggingRectMode({aspectRatio: aspectRatio.value, next})],
    // ["mode", (_, next) => cs(
    //     ({drawing, dragging}) => next(isDevQuan() ? dragging : drawing),
    // )],
    ({dragging, aspectRatio, drawing}) => next({
        modePanel: ({mobile, onCancel}) => (mobile ? MobileControlPanel : DesktopControlPanel)({
            ready: !!dragging.ready,
            onCancel,
            onDone: () => onDone(dragging.rect),
            content: AspectRatioControl({mobile, state: aspectRatio}),
        }),
        renderOverlay: ({frame, desktop}) => cs(
            keyed(dragging.ready),
            () => !dragging.ready ? (
                aspectRatio.value != null ? (
                    AutoRect({
                        frame, desktop,
                        onDone: dragging.activate,
                        aspectRatio: aspectRatio.value,
                    })
                ) : (
                    drawing.render({
                        frame, desktop,

                        getBgColor: getColor,
                        onDone: dragging.activate,
                    })
                )
            ) : (
                dragging.render({
                    frame,
                    getBgColor: getColor,
                })
            ),
        ),
    }),
);
